import React, { FC, useCallback } from 'react'
import './index.scss'
import refreshIcon from 'assets/images/icons/refresh.svg'
import { NavigationLeftIco } from '../../../modules/CustomIcons'
import { Space } from 'antd'

interface StatusProps {
  leftValue: string
  rightValue?: string
  statusType?: string
  className?: string
  icon?: React.ReactNode
  onClickLeft?: () => void
  onClickRight?: () => void
}

export const ScreenTitle: FC<StatusProps> = ({
  leftValue,
  rightValue,
  onClickLeft,
  onClickRight,
  icon,
  statusType,
}) => {
  return (
    <div className={'screenTitle'}>
      <Space>
        <a className="screenTitle__title" onClick={onClickLeft}>
          <NavigationLeftIco />
          <span className={'screenTitle__title-text'}>{leftValue}</span>
        </a>
        {icon}
      </Space>
      <div className={'screenTitle__right'}>
        <a onClick={onClickRight}>
          <img src={refreshIcon} />
        </a>
        <span className={'screenTitle__right-text'}>{rightValue}</span>
      </div>
    </div>
  )
}
